import { render, staticRenderFns } from "./RecordTopBar.vue?vue&type=template&id=38bf0348&"
import script from "./RecordTopBar.vue?vue&type=script&lang=js&"
export * from "./RecordTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports